import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './context/ThemeContext';
import { AuthContextProvider } from './auth/AuthContext';
import { HashRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
    <CookiesProvider>
    <AuthContextProvider>
      <ThemeProvider>
    <App />
    </ThemeProvider>
    </AuthContextProvider>
    </CookiesProvider>
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
